import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@src/utils/baseQuery";
import { APIResponse } from "./CommonApiSlice";
import { Pageable } from "@src/types/CommonTypes";

export interface OrganizationRequest {
  name: string;
  type: string;
  phoneNumber: string;
  address: string;
  country: string;
  state: string;
  pinCode: string;
  organizationEmail: string;
  parentId: string;
  websiteUrl: string;
}

export interface CreateSubOrgPayload {
  organizationRequest: OrganizationRequest;
  adderEmail: string;
}

export interface Client {
  createdOn: string;
  lastUpdateOn: string;
  createdByName: string;
  createdByEmail: string;
  modifiedByName: string;
  modifiedByEmail: string;
  id: string;
  name: string;
  parentReference: string;
  organizationType: string;
  country: string;
  state: string;
  district: string;
  city: string;
  address: string;
  email: string;
  phoneNumber: string;
}

interface GetAllClientsForOrgApiResponse extends APIResponse {
  response: {
    totalPages: number;
    totalElements: number;
    size: number;
    content: Client[];
    last: boolean;
    pageable: Pageable;
  };
}

export const ClientsApiSlice = createApi({
  reducerPath: "ClientsApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllClients: builder.query<
      GetAllClientsForOrgApiResponse,
      { parentId?: string; pageNo: number; pageSize: number; type: string }
    >({
      query: ({ parentId, pageNo, pageSize, type }) => ({
        url: `organization/get-all-organization?type=${type}&pageNo=${pageNo}&pageSize=${pageSize}&parentId=${parentId}`,
        method: "GET",
      }),
    }),
    createClients: builder.mutation<
      any,
      { organizationRequest: string; adderEmail: string }
    >({
      query: ({ adderEmail, organizationRequest }) => {
        const formData = new FormData();
        formData.append("organizationRequest", organizationRequest.toString());

        return {
          url: `organization?adderEmail=${adderEmail}`,
          method: "POST",
          body: formData,
        };
      },
    }),
  }),
});

export const {
  useGetAllClientsQuery,
  useLazyGetAllClientsQuery,
  useCreateClientsMutation,
} = ClientsApiSlice;
